import React from 'react'
import _ from 'lodash'
import cn from 'classnames'

export default class Dropdown extends React.Component {
  static defaultProps = {
    tag: 'div',
    className: '',
    trigger: null,
    align: 'left',
  }

  constructor() {
    super()
    this.state = {
      show: false,
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.handleOutsideClick)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick = (e) => {
    if ((this.compRef && !this.compRef.contains(e.target)) // cuz Tag could be Fragment, so no dom
      || !this.menuRef.contains(e.target)) {
      this.setState({ show: false })
    }
  }

  toggle = (e) => {
    e.stopPropagation()

    this.setState({
      show: !this.state.show
    })
  }

  render () {
    const { show } = this.state
    const { tag: Tag, trigger, children, className, align } = this.props

    return (
      <Tag className={cn('dropdown', className)} ref={(r) => { this.compRef = r }}>
        {React.cloneElement(trigger, {
          onClick: (e) => {
            this.toggle(e)
            trigger.props.onClick && trigger.props.onClick(e)
          }
        })}
        <div
          className={cn('dropdown-menu', {
            show,
            'dropdown-menu-right': align === 'right',
          })}
          ref={(r) => { this.menuRef = r }}
        >
          {_.isFunction(children)
            ? children(this.toggle) 
            : React.Children.map(children, (c) => (
              React.cloneElement(c, {
                onClick: (e) => {
                  if (!_.isFunction(children)) {
                    this.toggle(e)
                  }

                  c.props.onClick(e)
                }
              })
            ))
          }
        </div>
      </Tag>
    )
  }
}
